import Vue from 'vue'
import Vuex from 'vuex'
import actions from './service/actions'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    adminSeq: 0,
    email: '',
    level: 0,
    errState: '',
    token: '',
    isAuth: false,
    isSidebar: true
  },
  getters: {
    getAdminSeq: state => state.adminSeq,
    getEmail: state => state.email,
    getLevel: state => state.level,
    getErrState: state => state.errState,
    getToken: state => state.token,
    getAuth: state => state.isAuth
  },
  mutations: {
    toggleSidebar(state) {
      state.isSidebar = !state.isSidebar
    },
    changeAdminSeq(state, payload) {
      state.adminSeq = payload
    },
    changeEmail(state, payload) {
      state.email = payload
    },
    changeLevel(state, payload) {
      state.level = payload
    },
    changeState(state, payload) {
      state.errState = payload
    },
    changeToken(state, payload) {
      state.token = payload
    },
    changeAuth(state, payload) {
      state.isAuth = payload
    }
  },
  actions
});



// WEBPACK FOOTER //
// ./src/store.js